import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MaterialModule } from '../../material.module';
import { CommonModule } from '@angular/common';
import { FormGroup, Validators } from '@angular/forms';
import { statusCodesAttachmentFormFieldConfig } from '../statuscodes/statuscodes.config';
import { ValidatorService } from '../../services/form-control-validators.service';
import { FormField } from '../../models/dynamic.model';
import { CommonService } from '../../services/common.service';
import {
  ActionIcons,
  fileMaximumSize,
  fileNameExtensions,
  SvgIconFrom,
} from '../../utility/constants';
import { AttachmentUploadService } from '../../services/attachment-upload.service';
import { CustomErrorTooltipComponent } from '../custom-error-tooltip/custom-error-tooltip.component';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-statuscode-attachments',
  standalone: true,
  imports: [MaterialModule, CommonModule,CustomErrorTooltipComponent,SharedModule],
  templateUrl: './statuscode-attachments.component.html',
  styleUrl: './statuscode-attachments.component.scss',
  providers: [AttachmentUploadService],
})
export class StatuscodeAttachmentsComponent implements OnInit {
  public rowData: any;
  public createAttchementForm!: FormGroup;
  public formField!: FormField[];
  public errorMessages!: any;
  public fileName: string | null = null;
  public originFileName: string ='';
  public selectedFile: any = [];
  public readonly upload = inject(AttachmentUploadService);
  private readonly destroyRef = inject(DestroyRef);
  public setgInfoErrorTooltip: any = {};
  public icons = ActionIcons;
  public actionIconsList = ActionIcons;
  setTooltipInfoWidth: any = {};
  setInfoTooltipEvent: any = {};
  setInfoErrorTooltip: any = {};
   public svgIconFromList = SvgIconFrom;

  constructor(
    private readonly formServices: ValidatorService,
    public commonService: CommonService
  ) {
    this.setReqInit();
  }

  ngOnInit(): void {
  if (this.rowData) {
    this.patchForm(this.rowData);
  }
  }
  private createForm() {
    const { form, errorMessages } = this.formServices.generateForm(
      statusCodesAttachmentFormFieldConfig
    , this.destroyRef);
    this.createAttchementForm = form;
    this.errorMessages = errorMessages;
  }

  private setReqInit() {
    this.createForm();  
    this.formField = statusCodesAttachmentFormFieldConfig.fields;    
  }
  private patchForm(data: any) {
  // Row-level `description` is the status code description, not the
  // attachment's. Saved rows carry the attachment under statusCodeAttachments.
  const attachment =
    data.statusCodeAttachments?.attachmentList?.[0] ??
    data.attachmentList?.[0];

  this.createAttchementForm.patchValue({
    attachmentId: data.attachments ?? '',
    description: attachment?.description ?? '',
  });

  // Optional: show file name
  if (attachment) {
    this.fileName = attachment.fileName;
    this.originFileName = attachment.originFileName;
  }
    this.createAttchementForm.disable();
}


  /** Read by the popup to keep Save disabled until the upload settles. */
  public get isUploading(): boolean {
    return this.upload.isUploading;
  }

  onAttachmentFileSelected(event: any): void {
    this.selectedFile = event.target.files[0];
    const data = {
      fileName: this.selectedFile.name,
      requestType: 'IBC',
    };

    this.checkFileTypeValidation();
    this.createAttchementForm.get('attachmentId')?.setValue(this.selectedFile.name);   
    this.upload
      .upload(data, this.selectedFile, this.createAttchementForm)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((signedData: any) => {
        this.fileName = signedData?.fileName;
        this.originFileName = signedData?.originFileName;
      });
  }
  private checkFileTypeValidation() {
    const checkFileValidations = Validators.compose([
      this.commonService.fileExtensionValidator(
        this.selectedFile,
        fileNameExtensions
      ),
      this.commonService.fileSizeValidator(this.selectedFile, fileMaximumSize),
    ]);
    this.createAttchementForm
      .get('attachmentId')
      ?.setValidators(checkFileValidations);
    this.createAttchementForm.get('attachmentId')?.updateValueAndValidity();
  }

 public getAttachmentErrorMessage(controlName: string): string {
    return this.formServices.getErrorMessage(
      this.createAttchementForm,
      this.errorMessages,
      controlName
    );
  }

  public fetchWidth(event: MouseEvent, fieldName: string) {
    this.commonService.setErrorTooltipData(
      event,
      fieldName,
      this.setTooltipInfoWidth,
      this.setInfoTooltipEvent,
      this.setInfoErrorTooltip
    );
  }
  public checkControlHasError(controlName: string) {
    return this.commonService.checkControlError(this.createAttchementForm, controlName);
  }
}
